export default __webpack_public_path__ + "static/media/rambouillet04.80a86f7a.jpg";